import { Action } from '@ngrx/store';

export enum CentralActionTypes {
  //fetch my help components
  FETCH_MY_HELP_COMPONENTS = '[Central] Fetch My Help Components',
  FETCH_MY_HELP_COMPONENTS_SUCCESS = '[Central] Fetch My Help Components Success',
  FETCH_MY_HELP_COMPONENTS_FAILED = '[Central] Fetch My Help Components Failed',

  // Load tasks
  LOAD_TASKS = '[Central] Load Tasks',
  LOAD_TASKS_SUCCESS = '[Central] Load Tasks Success',
  LOAD_TASKS_FAILED = '[Central] Load Tasks Failed',
  // Load task details
  LOAD_TASK_DETAILS = '[Central] Load Task Details',
  LOAD_TASK_DETAILS_SUCCESS = '[Central] Load Task Details Success',
  LOAD_TASK_DETAILS_FAILED = '[Central] Load Task Details Failed',
  // Update task
  UPDATE_TASK = '[Central] Update Task',
  UPDATE_TASK_SUCCESS = '[Central] Update Task Success',
  UPDATE_TASK_FAILED = '[Central] Update Task Failed',
  // Fetch site list
  FETCH_SITE_LIST = '[Central] Fetch Site List',
  FETCH_SITE_LIST_SUCCESS = '[Central] Fetch Site List Success',
  FETCH_SITE_LIST_FAILED = '[Central] Fetch Site List Failed',
  // Fetch salespeople list
  FETCH_SALESPEOPLE_LIST = '[Central] Fetch Sales People List',
  FETCH_SALESPEOPLE_LIST_SUCCESS = '[Central] Fetch Sales People List Success',
  FETCH_SALESPEOPLE_LIST_FAILED = '[Central] Fetch Sales People List Failed',
  // Fetch task summary
  FETCH_TASK_SUMMARY = '[Central] Fetch Task Summary',
  FETCH_TASK_SUMMARY_SUCCESS = '[Central] Fetch Task Summary Success',
  FETCH_TASK_SUMMARY_FAILED = '[Central] Fetch Task Summary Failed',

  LOAD_TASK_LIST = '[Central] Load Task List',
  LOAD_TASK_LIST_SUCCESS = '[Central] Load Task List Success',
  LOAD_TASK_LIST_FAILED = '[Central] Load Task List Failed',

  LOAD_TASK_TOTAL_COUNT = '[Central] Load Task Total Count',
  LOAD_TASK_TOTAL_COUNT_SUCCESS = '[Central] Load Task Total Count Success',
  LOAD_TASK_TOTAL_COUNT_FAILED = '[Central] Load Task Total Count Failed',

  LOAD_CENTRAL_TASKS = '[Central] Load Central Tasks',
  LOAD_CENTRAL_TASKS_SUCCESS = '[Central] Load Central Tasks Success',
  LOAD_CENTRAL_TASKS_FAILED = '[Central] Load Central Tasks Failed',

  // Load job request totals
  LOAD_OPEN_JOB_REQUEST_TOTALS = '[Central] Load Job Request Totals',
  LOAD_OPEN_JOB_REQUEST_TOTALS_SUCCESS = '[Central] Load Open Job Request Totals Success',
  LOAD_OPEN_JOB_REQUEST_TOTALS_FAILED = '[Central] Load Open Job Request Totals Failed',

  // Save active navigation index
  SAVE_ACTIVE_NAV_INDEX = '[Central] Save Active Navigation Index',
}

class BaseAction implements Action {
  constructor(public type: string, public payload?: any) {}
}
export class FetchMyHelpComponents extends BaseAction {
  readonly type = CentralActionTypes.FETCH_MY_HELP_COMPONENTS;
  constructor() {
    super(CentralActionTypes.FETCH_MY_HELP_COMPONENTS);
  }
}
export class FetchMyHelpComponentsSuccess extends BaseAction {
  readonly type = CentralActionTypes.FETCH_MY_HELP_COMPONENTS_SUCCESS;
  constructor(public payload: any) {
    super(CentralActionTypes.FETCH_MY_HELP_COMPONENTS_SUCCESS, payload);
  }
}
export class FetchMyHelpComponentsFailed extends BaseAction {
  readonly type = CentralActionTypes.FETCH_MY_HELP_COMPONENTS_FAILED;
  constructor(public payload: any) {
    super(CentralActionTypes.FETCH_MY_HELP_COMPONENTS_FAILED, payload);
  }
}

export class LoadTasks extends BaseAction {
  readonly type = CentralActionTypes.LOAD_TASKS;
  constructor(public payload: any) {
    super(CentralActionTypes.LOAD_TASKS, payload);
  }
}

export class LoadTasksSuccess extends BaseAction {
  readonly type = CentralActionTypes.LOAD_TASKS_SUCCESS;
  constructor(public payload: any) {
    super(CentralActionTypes.LOAD_TASKS_SUCCESS, payload);
  }
}

export class LoadTasksFailed extends BaseAction {
  readonly type = CentralActionTypes.LOAD_TASKS_FAILED;
  constructor(public payload: any) {
    super(CentralActionTypes.LOAD_TASKS_FAILED, payload);
  }
}

export class LoadTaskDetails extends BaseAction {
  readonly type = CentralActionTypes.LOAD_TASK_DETAILS;
  constructor(public payload: any) {
    super(CentralActionTypes.LOAD_TASK_DETAILS, payload);
  }
}

export class LoadTaskDetailsSuccess extends BaseAction {
  readonly type = CentralActionTypes.LOAD_TASK_DETAILS_SUCCESS;
  constructor(public payload: any) {
    super(CentralActionTypes.LOAD_TASK_DETAILS_SUCCESS, payload);
  }
}

export class LoadTaskDetailsFailed extends BaseAction {
  readonly type = CentralActionTypes.LOAD_TASK_DETAILS_FAILED;
  constructor(public payload: any) {
    super(CentralActionTypes.LOAD_TASK_DETAILS_FAILED, payload);
  }
}

export class UpdateTask extends BaseAction {
  readonly type = CentralActionTypes.UPDATE_TASK;
  constructor(public payload: any) {
    super(CentralActionTypes.UPDATE_TASK, payload);
  }
}

export class UpdateTaskSuccess extends BaseAction {
  readonly type = CentralActionTypes.UPDATE_TASK_SUCCESS;
  constructor(public payload: any) {
    super(CentralActionTypes.UPDATE_TASK_SUCCESS, payload);
  }
}

export class UpdateTaskFailed extends BaseAction {
  readonly type = CentralActionTypes.UPDATE_TASK_FAILED;
  constructor(public payload: any) {
    super(CentralActionTypes.UPDATE_TASK_FAILED, payload);
  }
}

export class FetchSiteList extends BaseAction {
  readonly type = CentralActionTypes.FETCH_SITE_LIST;
  constructor() {
    super(CentralActionTypes.FETCH_SITE_LIST);
  }
}

export class FetchSiteListSuccess extends BaseAction {
  readonly type = CentralActionTypes.FETCH_SITE_LIST_SUCCESS;
  constructor(public payload: any) {
    super(CentralActionTypes.FETCH_SITE_LIST_SUCCESS, payload);
  }
}

export class FetchSiteListFailed extends BaseAction {
  readonly type = CentralActionTypes.FETCH_SITE_LIST_FAILED;
  constructor(public payload: any) {
    super(CentralActionTypes.FETCH_SITE_LIST_FAILED, payload);
  }
}

export class FetchSalesPeopleList extends BaseAction {
  readonly type = CentralActionTypes.FETCH_SALESPEOPLE_LIST;
  constructor() {
    super(CentralActionTypes.FETCH_SALESPEOPLE_LIST);
  }
}

export class FetchSalesPeopleListSuccess extends BaseAction {
  readonly type = CentralActionTypes.FETCH_SALESPEOPLE_LIST_SUCCESS;
  constructor(public payload: any) {
    super(CentralActionTypes.FETCH_SALESPEOPLE_LIST_SUCCESS, payload);
  }
}

export class FetchSalesPeopleListFailed extends BaseAction {
  readonly type = CentralActionTypes.FETCH_SALESPEOPLE_LIST_FAILED;
  constructor(public payload: any) {
    super(CentralActionTypes.FETCH_SALESPEOPLE_LIST_FAILED, payload);
  }
}

export class FetchTaskSummary extends BaseAction {
  readonly type = CentralActionTypes.FETCH_TASK_SUMMARY;
  constructor(public payload: any) {
    super(CentralActionTypes.FETCH_TASK_SUMMARY, payload);
  }
}

export class FetchTaskSummarySuccess extends BaseAction {
  readonly type = CentralActionTypes.FETCH_TASK_SUMMARY_SUCCESS;
  constructor(public payload: any) {
    super(CentralActionTypes.FETCH_TASK_SUMMARY_SUCCESS, payload);
  }
}

export class FetchTaskSummaryFailed extends BaseAction {
  readonly type = CentralActionTypes.FETCH_TASK_SUMMARY_FAILED;
  constructor(public payload: any) {
    super(CentralActionTypes.FETCH_TASK_SUMMARY_FAILED, payload);
  }
}

export class LoadTaskList extends BaseAction {
  readonly type = CentralActionTypes.LOAD_TASK_LIST;
  constructor(public payload: any) {
    super(CentralActionTypes.LOAD_TASK_LIST, payload);
  }
}

export class LoadTaskListSuccess extends BaseAction {
  readonly type = CentralActionTypes.LOAD_TASK_LIST_SUCCESS;
  constructor(public payload: any) {
    super(CentralActionTypes.LOAD_TASK_LIST_SUCCESS, payload);
  }
}

export class LoadTaskListFailed extends BaseAction {
  readonly type = CentralActionTypes.LOAD_TASK_LIST_FAILED;
  constructor(public payload: any) {
    super(CentralActionTypes.LOAD_TASK_LIST_FAILED, payload);
  }
}
export class LoadTaskTotalCount extends BaseAction {
  readonly type = CentralActionTypes.LOAD_TASK_TOTAL_COUNT;
  constructor(public payload: any) {
    super(CentralActionTypes.LOAD_TASK_TOTAL_COUNT, payload);
  }
}

export class LoadTaskTotalCountSuccess extends BaseAction {
  readonly type = CentralActionTypes.LOAD_TASK_TOTAL_COUNT_SUCCESS;
  constructor(public payload: any) {
    super(CentralActionTypes.LOAD_TASK_TOTAL_COUNT_SUCCESS, payload);
  }
}

export class LoadTaskTotalCountFailed extends BaseAction {
  readonly type = CentralActionTypes.LOAD_TASK_TOTAL_COUNT_FAILED;
  constructor(public payload: any) {
    super(CentralActionTypes.LOAD_TASK_TOTAL_COUNT_FAILED, payload);
  }
}

export class SaveActiveNavIndex extends BaseAction {
  readonly type = CentralActionTypes.SAVE_ACTIVE_NAV_INDEX;
  constructor(public payload: any) {
    super(CentralActionTypes.SAVE_ACTIVE_NAV_INDEX, payload);
  }
}

export class LoadCentralTasks extends BaseAction {
  readonly type = CentralActionTypes.LOAD_CENTRAL_TASKS;
  constructor() {
    super(CentralActionTypes.LOAD_CENTRAL_TASKS, {});
  }
}

export class LoadCentralTasksSuccess extends BaseAction {
  readonly type = CentralActionTypes.LOAD_CENTRAL_TASKS_SUCCESS;
  constructor(public payload: any) {
    super(CentralActionTypes.LOAD_CENTRAL_TASKS_SUCCESS, payload);
  }
}

export class LoadCentralTasksFailed extends BaseAction {
  readonly type = CentralActionTypes.LOAD_CENTRAL_TASKS_FAILED;
  constructor(public payload: any) {
    super(CentralActionTypes.LOAD_CENTRAL_TASKS_FAILED, payload);
  }
}

export class LoadOpenJobRequestTotals extends BaseAction {
  readonly type = CentralActionTypes.LOAD_OPEN_JOB_REQUEST_TOTALS;
  constructor() {
    super(CentralActionTypes.LOAD_OPEN_JOB_REQUEST_TOTALS, {});
  }
}

export class LoadOpenJobRequestTotalsSuccess extends BaseAction {
  readonly type = CentralActionTypes.LOAD_OPEN_JOB_REQUEST_TOTALS_SUCCESS;
  constructor(public payload: any) {
    super(CentralActionTypes.LOAD_OPEN_JOB_REQUEST_TOTALS_SUCCESS, payload);
  }
}

export class LoadOpenJobRequestTotalsFailed extends BaseAction {
  readonly type = CentralActionTypes.LOAD_OPEN_JOB_REQUEST_TOTALS_FAILED;
  constructor(public payload: any) {
    super(CentralActionTypes.LOAD_OPEN_JOB_REQUEST_TOTALS_FAILED, payload);
  }
}

export type CentralAction =
  | FetchMyHelpComponents
  | FetchMyHelpComponentsSuccess
  | FetchMyHelpComponentsFailed
  | LoadTasks
  | LoadTasksSuccess
  | LoadTasksFailed
  | LoadTaskDetails
  | LoadTaskDetailsSuccess
  | LoadTaskDetailsFailed
  | UpdateTask
  | UpdateTaskSuccess
  | UpdateTaskFailed
  | FetchSiteList
  | FetchSiteListSuccess
  | FetchSiteListFailed
  | FetchSalesPeopleList
  | FetchSalesPeopleListSuccess
  | FetchSalesPeopleListFailed
  | FetchTaskSummary
  | FetchTaskSummarySuccess
  | FetchTaskSummaryFailed
  | LoadTaskList
  | LoadTaskListSuccess
  | LoadTaskListFailed
  | SaveActiveNavIndex
  | LoadCentralTasks
  | LoadCentralTasksSuccess
  | LoadCentralTasksFailed
  | LoadOpenJobRequestTotals
  | LoadOpenJobRequestTotalsSuccess 
  | LoadOpenJobRequestTotalsFailed

export const fromCentralActions = {};

